import { GridHeaderCellProps } from '@progress/kendo-react-grid';
import { useMemo } from 'react';
import ExpandCollapseCell from 'src/components/custom-cells/ExpandCollapseCell';
import useViewAccrual from 'src/hooks/useViewAccrual';

const AccrualHeaderCell = (props: GridHeaderCellProps) => {
  const { accrualReport, setAccrualReport } = useViewAccrual();
  const isAllExpanded = useMemo(
    () => accrualReport?.some?.((glCode: any) => glCode.expanded),
    [accrualReport]
  );

  const handleHeaderCellExpand = () => {
    setAccrualReport((prev) => [...prev].map((item) => ({ ...item, expanded: !isAllExpanded })));
  };

  return (
    <th className="k-header k-hierarchy-cell" style={{ borderBottomWidth: '0px' }}>
      <ExpandCollapseCell
        title="Expand/Collapse All"
        expand={isAllExpanded}
        onExpand={handleHeaderCellExpand}
      />
    </th>
  );
};

export default AccrualHeaderCell;
